import { Banner, Button, Stack, TextContainer, Text, Icon } from "@shopify/polaris";
import { CircleAlertMajor } from '@shopify/polaris-icons'
import { useEffect } from "react";
import styles from './RedirectConfigsInfoBanner.module.css';

const RedirectConfigsInfoBanner = ({ setIsBannerChecked, bannerValidError, setBannerValidError }) => {
    useEffect(() => {
        setIsBannerChecked(false);
        setBannerValidError(false);
    }, [setIsBannerChecked]);

    const handleButtonClick = () => {
        setIsBannerChecked(true);
    };

    return (
        <div className={styles.bannerWrapper}>
            <div className={bannerValidError ? styles.shake : ''}>
                <Banner status="warning">
                    <Stack vertical>
                        <TextContainer>
                            <Text as="p" variant="bodyLg">
                                Heads up! If you use our redirect feature while a product is hidden, please note that once the product is visible again, customers can still be redirected to the URL you assigned. If this happens, please clear your cache or use a different browser to open the product. The redirect will clear on its own according to Shopify's timeline.
                            </Text>
                        </TextContainer>
                        <div className={styles.bannerContent}>
                            <Stack alignment="center" spacing="tight">
                                {bannerValidError && (
                                    <div className={styles.errorWrapper}>
                                        <Icon source={CircleAlertMajor} color="critical" />
                                        <p className={styles.errorText}>Required</p>
                                    </div>
                                )}
                                <Button onClick={handleButtonClick}>
                                    OK
                                </Button>
                            </Stack>
                        </div>
                    </Stack>
                </Banner>
            </div>
        </div >
    );
};

export default RedirectConfigsInfoBanner;